module.exports = __webpack_public_path__ + "img/avatar.cf02062b.svg";